/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".componentTable{border-collapse:collapse;width:100%}.componentBadgeCell{padding:8px;text-align:right;border-bottom:1px solid #ddd}.componentCells{padding:8px;text-align:left;border-bottom:1px solid #ddd}\n"}]);